import { Link } from "react-router-dom";
import "./style.css";

export default function PlaylistCard({ playlist, onClick }) {
  const getPrivacyLabel = (privacy) => {
    switch (privacy) {
      case "public":
        return "Público";
      case "friends":
        return "Amigos";
      case "only_me":
        return "Privado";
      default:
        return privacy;
    }
  };

  const getPrivacyIcon = (privacy) => {
    switch (privacy) {
      case "public":
        return (
          <svg viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
          </svg>
        );
      case "friends":
        return (
          <svg viewBox="0 0 24 24">
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
          </svg>
        );
      case "only_me":
        return (
          <svg viewBox="0 0 24 24">
            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="playlist_card" onClick={onClick}>
      <div className="playlist_card_thumbnail">
        {playlist.thumbnail ? (
          <img src={playlist.thumbnail} alt={playlist.title} />
        ) : (
          <div className="playlist_card_thumbnail_placeholder">
            <svg viewBox="0 0 24 24">
              <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z" />
            </svg>
          </div>
        )}
        <div className="playlist_card_count">
          <svg viewBox="0 0 24 24">
            <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z" />
          </svg>
          {playlist.items?.length || 0} vídeos
        </div>
        {playlist.privacy !== "public" && (
          <div className="playlist_card_privacy">
            {getPrivacyIcon(playlist.privacy)}
            {getPrivacyLabel(playlist.privacy)}
          </div>
        )}
      </div>
      <div className="playlist_card_body">
        <div className="playlist_card_title">{playlist.title}</div>
        {playlist.description && (
          <div className="playlist_card_description">{playlist.description}</div>
        )}
        <div className="playlist_card_meta">
          <Link
            to={`/profile/${playlist.user?.username}`}
            className="playlist_card_user"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={playlist.user?.picture} alt="" />
            <span>
              {playlist.user?.first_name} {playlist.user?.last_name}
            </span>
          </Link>
          <div className="playlist_card_stats">
            <span>
              <svg viewBox="0 0 24 24">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
              </svg>
              {playlist.viewCount || 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
